import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

import { fetchBrands, fetchBrandsSearch } from 'api/fetchers/fetchBrands'
import { useIsAdmin } from 'hooks/useIsAdmin'
import { BrandApiResponse } from 'model/BrandApiResponse'

interface BrandParams {
  page?: number
  limit?: number
  search?: string
  isHighlighted?: boolean
  searchTerm?: string
  sortedBy?: string
  version?: string
}

export const useBrandDetails = (
  { page = 1, limit = 10, search = '', isHighlighted = true }: BrandParams = {},
  enabled = true,
) => {
  const params = { limit, search, isHighlighted }

  return useQuery({
    queryKey: ['brands', params],
    queryFn: ({ signal }: any) => fetchBrands(params, page)(signal),
    select: (data: any) => data?.data,
    enabled,
  })
}

export const useBrands = ({
  searchTerm,
  version,
  sortedBy,
}: {
  searchTerm: string
  version: string
  sortedBy: string
}) => {
  const { isAdmin } = useIsAdmin()
  const includeDraft = isAdmin ? true : false

  return useInfiniteQuery<BrandApiResponse>({
    queryKey: ['BVAlist', searchTerm, version, sortedBy, includeDraft],
    queryFn: ({ pageParam = 1, signal }) =>
      fetchBrandsSearch(
        {
          page: pageParam,
          limit: 10,
          includeDraft: includeDraft,
          searchTerm: searchTerm,
          sortedBy: sortedBy,
          version: version,
        },
        signal,
      ),

    getNextPageParam: lastPage => {
      const { page, limit, total } = lastPage.meta
      return page * limit < total ? page + 1 : undefined
    },
    cacheTime: 0,
  })
}
